import Service, { service } from '@ember/service';

import ENV from 'register-partners-js/config/environment';

export default class MetricsManager extends Service {
  @service metrics;
  @service cookiesConsentManager;
  @service segment;

  activateMetricsAdapters() {
    if (this.canActivateMetricsAdapters) {
      let adapters = [];

      if (this.hasGoogleTagManagerAdapterConfig) {
        adapters.push(this.googleTagManagerMetricAdapter);
      }

      if (this.hasSegmentAdapterConfig) {
        adapters.push(this.segmentMetricAdapter);
      }

      if (adapters.length) {
        this.metrics.activateAdapters(adapters);

        if (this.hasSegmentAdapterConfig) {
          this.segment.initialize();
        }
      }
    }
  }

  get hasGoogleTagManagerAdapterConfig() {
    return Boolean(ENV.metricsAdaptersConfig.LocalGoogleTagManager);
  }

  get googleTagManagerMetricAdapter() {
    let { config, environments } = ENV.metricsAdaptersConfig.LocalGoogleTagManager;

    return {
      name: 'LocalGoogleTagManager',
      config,
      environments,
    };
  }

  get hasSegmentAdapterConfig() {
    return ENV.metricsAdaptersConfig.Segment;
  }

  get segmentMetricAdapter() {
    let { config, environments } = ENV.metricsAdaptersConfig.Segment;
    let integrations = this.cookiesConsentManager.getSegmentIntegrations();

    return {
      name: 'LocalSegment',
      config: { key: config.key, options: { integrations } },
      environments,
    };
  }

  get canActivateMetricsAdapters() {
    return (
      typeof ENV.metricsAdaptersConfig === 'object' &&
      (this.hasGoogleTagManagerAdapterConfig || this.hasSegmentAdapterConfig)
    );
  }
}
